/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import DrawerListProperties from 'Docs/uilib/components/fragments/drawer-list/properties';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.p, {
      children: ["You may check out the ", _jsx(_components.a, {
        href: "#drawerlist-properties",
        children: "DrawerList Properties"
      }), " down below as well as the ", _jsx(_components.a, {
        href: "#data-structure",
        children: "Data structure examples"
      }), "."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " give a title to let the users know what they have to do. Defaults to ", _jsx(_components.code, {
              children: "Valgmeny"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "value"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a preselected data entry (index). More info down below."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "variant"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the kind of dropdown. Possible values are ", _jsx(_components.code, {
              children: "primary"
            }), ", ", _jsx(_components.code, {
              children: "secondary"
            }), ", ", _jsx(_components.code, {
              children: "tertiary"
            }), " and ", _jsx(_components.code, {
              children: "signal"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "secondary"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " icon to be included in the dropdown."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " change the size of the icon pragmatically."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_position"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " position of the icon inside the dropdown. Set to ", _jsx(_components.code, {
              children: "left"
            }), " or ", _jsx(_components.code, {
              children: "right"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "right"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "triangle_position"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " position of arrow / triangle of the drawer. Set to ", _jsx(_components.code, {
              children: "left"
            }), " or ", _jsx(_components.code, {
              children: "right"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "right"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define the height of the Dropdown. Can be set to ", _jsx(_components.code, {
              children: "small"
            }), ", ", _jsx(_components.code, {
              children: "default"
            }), ", ", _jsx(_components.code, {
              children: "medium"
            }), " and ", _jsx(_components.code, {
              children: "large"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "default"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "opened"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the Dropdown will be rendered initially with a visible and accessible data list / options."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "open_on_focus"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", the Dropdown will be opened when the users enter the trigger button with a focus action."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "prevent_selection"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", no permanent selection will be made. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "action_menu"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " same as ", _jsx(_components.code, {
              children: "prevent_selection"
            }), ", but the DrawerList will be opened from the bottom of the page for mobile devices. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "more_menu"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " same as ", _jsx(_components.code, {
              children: "prevent_selection"
            }), ", but the \"selection area\" (given title) will not be visible and the icon ", _jsx(_components.code, {
              children: "more"
            }), " (three dots) is used. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "align_dropdown"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "right"
            }), " to change the options alignment direction. Makes only sense to use in combination with ", _jsx(_components.code, {
              children: "prevent_selection"
            }), " or ", _jsx(_components.code, {
              children: "more_menu"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "left"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "independent_width"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " If set to ", _jsx(_components.code, {
              children: "true"
            }), ", the Dropdown will handle it's width independent to the content width. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skip_portal"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " to disable the React Portal behavior. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "stretch"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", then the dropdown will be 100% in available ", _jsx(_components.code, {
              children: "width"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " text with a status message. The style defaults to an error message. You can use ", _jsx(_components.code, {
              children: "true"
            }), " to only get the status color, without a message."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the state of the status. Currently, there are two statuses ", _jsx(_components.code, {
              children: "[error, info]"
            }), ". Defaults to ", _jsx(_components.code, {
              children: "error"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_props"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use an object to define additional FormStatus properties."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "globalStatus"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the ", _jsx(_components.a, {
              href: "/uilib/components/global-status/properties/#configuration-object",
              children: "configuration"
            }), " used for the target ", _jsx(_components.a, {
              href: "/uilib/components/global-status",
              children: "GlobalStatus"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " prepends the Form Label component. If no ID is provided, a random ID is created."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label_direction"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "label_direction=\"vertical\""
            }), " to change the label layout direction. Defaults to ", _jsx(_components.code, {
              children: "horizontal"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label_sr_only"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " use ", _jsx(_components.code, {
              children: "true"
            }), " to make the label only readable by screen readers."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "suffix"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " text describing the content of the Dropdown more than the label. You can also send in a React component, so it gets wrapped inside the Dropdown component."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "trigger_element"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " lets you provide a custom React element as the trigger HTML element."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "innerRef"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " by providing a React.ref you can get the internally used main element (DOM). E.g. ", _jsx(_components.code, {
              children: "innerRef={myRef}"
            }), " by using ", _jsx(_components.code, {
              children: "React.createRef()"
            }), " or ", _jsx(_components.code, {
              children: "React.useRef()"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "buttonRef"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " by providing a React.ref you can get the internally used button element (DOM). E.g. ", _jsx(_components.code, {
              children: "buttonRef={myRef}"
            }), " by using ", _jsx(_components.code, {
              children: "React.createRef()"
            }), " or ", _jsx(_components.code, {
              children: "React.useRef()"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "skeleton"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " if set to ", _jsx(_components.code, {
              children: "true"
            }), ", an overlaying skeleton with animation will be shown."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/components/fragments/drawer-list/properties",
              children: "DrawerList"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " all DrawerList properties."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsx(DrawerListProperties, {}), "\n", _jsx(_components.h2, {
      children: "Value"
    }), "\n", _jsxs(_components.p, {
      children: ["Should either be an index (integer) of the data array or a key – defined by ", _jsx(_components.code, {
        children: "selectedKey"
      }), " (the deprecated ", _jsx(_components.code, {
        children: "selected_key"
      }), " should not start with a number) inside an array item."]
    }), "\n", _jsxs(_components.p, {
      children: ["If ", _jsx(_components.code, {
        children: "data"
      }), " is an object, use the object key as the ", _jsx(_components.code, {
        children: "value"
      }), " to define the selected item. Can be a string or integer."]
    }), "\n", _jsx(_components.h2, {
      children: "Data structure"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "// 1. as array\nconst data = [\n  // Every data item can, beside \"content\" - contain what ever\n  {\n    // (optional) can be what ever\n    selectedKey: 'key_0',\n\n    // (optional) is show instead of \"content\", once selected\n    selected_value: 'Item 1 Value',\n    suffix_value: 'Addition 1',\n\n    // Item content as a string or array\n    content: 'Item 1 Content',\n  },\n\n  // more items ...\n  {\n    selectedKey: 'key_1',\n    content: ['Item 2 Value', 'Item 2 Content'],\n  },\n  {\n    selectedKey: 'key_2',\n    selected_value: 'Item 3 Value',\n    suffix_value: 'Addition 3',\n    content: ['Item 3 Content A', 'Item 3 Content B'],\n  },\n  {\n    selectedKey: 'key_3',\n    selected_value: 'Item 4 Value',\n    suffix_value: 'Addition 4',\n    content: ['Item 4 Content A', <>Custom Component</>],\n  },\n]\n\n// 2. as object\nconst data = {\n  a: 'A',\n  b: 'B',\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
